export const RaceCourseAssets = {
    1: {
        raceCourseTitle: 'Borrowdale Park Turf',
        raceCourseIcon: 'racecourse-barrowdalePark-turf',
        raceTrackIcon: 'racetrack-borrowdalePark-turf'
    },
    2: {
        raceCourseTitle: 'Durbanville Turf',
        raceCourseTitleLogoWhitePath: 'racecourse-title-logo-hollywoodbets-durbanville-white',
        raceCourseTitleLogoBlackPath: 'racecourse-title-logo-hollywoodbets-durbanville-black',
        raceCourseIcon: 'racecourse-durbanville-turf',
        raceTrackIcon: 'racetrack-durbanville-turf'
    },
    3: {
        raceCourseTitle: 'Fairview Poly',
        raceCourseIcon: 'racecourse-fairview-poly',
        raceTrackIcon: 'racetrack-fairview-poly'
    },
    4: {
        raceCourseTitle: 'Fairview Turf',
        raceCourseIcon: 'racecourse-fairview-turf',
        raceTrackIcon: 'racetrack-fairview-turf'
    },
    5: {
        raceCourseTitle: 'Flamingo Park Sand',
        raceCourseIcon: 'racecourse-flamingoPark-sand',
        raceTrackIcon: 'racetrack-flamingoPark-sand'
    },
    6: {
        raceCourseTitle: 'Hollywoodbets Greyville Poly',
        raceCourseTitleLogoWhitePath: 'racecourse-title-logo-hollywoodbets-greyville-white',
        raceCourseTitleLogoBlackPath: 'racecourse-title-logo-hollywoodbets-greyville-black',
        raceCourseIcon: 'racecourse-greyville-poly',
        raceTrackIcon: 'racetrack-greyville-poly'
    },
    7: {
        raceCourseTitle: 'Hollywoodbets Greyville Turf',
        raceCourseTitleLogoWhitePath: 'racecourse-title-logo-hollywoodbets-greyville-white',
        raceCourseTitleLogoBlackPath: 'racecourse-title-logo-hollywoodbets-greyville-black',
        raceCourseIcon: 'racecourse-greyville-turf',
        raceTrackIcon: 'racetrack-greyville-turf'
    },
    8: {
        raceCourseTitle: 'Kenilworth Turf',
        raceCourseTitleLogoWhitePath: 'racecourse-title-logo-hollywoodbets-kenilworth-white',
        raceCourseTitleLogoBlackPath: 'racecourse-title-logo-hollywoodbets-kenilworth-black',
        raceCourseIcon: 'racecourse-kenilworth-turf',
        raceTrackIcon: 'racetrack-kenilworth-turf'
    },
    9: {
        raceCourseTitle: 'Mauritius Turf',
        raceCourseIcon: 'racecourse-mauritius-turf',
        raceTrackIcon: 'racetrack-mauritius-turf'
    },
    10: {
        raceCourseTitle: 'Hollywoodbets Scottsville Turf Inner',
        raceCourseTitleLogoWhitePath: 'racecourse-title-logo-hollywoodbets-scottsville-white',
        raceCourseTitleLogoBlackPath: 'racecourse-title-logo-hollywoodbets-scottsville-black',
        raceCourseIcon: 'racecourse-scottsville-turf-inner',
        raceTrackIcon: 'racetrack-scottsville-turf-inner'
    },
    11: {
        raceCourseTitle: 'Hollywoodbets Scottsville Turf Standside',
        raceCourseTitleLogoWhitePath: 'racecourse-title-logo-hollywoodbets-scottsville-white',
        raceCourseTitleLogoBlackPath: 'racecourse-title-logo-hollywoodbets-scottsville-black',
        raceCourseIcon: 'racecourse-scottsville-turf-standside',
        raceTrackIcon: 'racetrack-scottsville-turf-standside'
    },
    12: {
        raceCourseTitle: 'Turffontein Turf Standside',
        raceCourseIcon: 'racecourse-turffontein-turf-standside',
        raceTrackIcon: 'racetrack-turffontein-turf-standside'
    },
    13: {
        raceCourseTitle: 'Turffontein Turf Inner',
        raceCourseIcon: 'racecourse-turffontein-turf-inner',
        raceTrackIcon: 'racetrack-turffontein-turf-inner'
    },
    14: {
        raceCourseTitle: 'Vaal Turf',
        raceCourseIcon: 'racecourse-vaal-turf',
        raceTrackIcon: 'racetrack-vaal-turf'
    },
    15: {
        raceCourseTitle: 'Vaal Turf Classic',
        raceCourseIcon: 'racecourse-vaal-turf-classic',
        raceTrackIcon: 'racetrack-vaal-turf-classic'
    }
};